var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 92,
    viewBox: "0 0 133 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 109,
    height: 26,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 33,
    width: 109,
    height: 54,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2929 16.2929L96.7071 13.7071C96.0771 13.0771 96.5233 12 97.4142 12H102.586C103.477 12 103.923 13.0771 103.293 13.7071L100.707 16.2929C100.317 16.6834 99.6834 16.6834 99.2929 16.2929Z",
    fill: "#624AB6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#EC9770"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#EC9770"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 59,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 73,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 70.5,
    r: 21.5,
    fill: "#E9706D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.734 81H115.016V59.8623H111.734L106.168 63.8174V67.04L111.485 63.2461H111.734V81Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step_1.7ef1c9de843edc700f70efe7fc9ad27e.svg";
export { ForwardRef as ReactComponent };